import sendGtmEvent from "web/utils/system/GTM/sendGtmEvent";

export const createGtmImpressionProps = (gtmOptions) => {
  const options = {
    ecommerce: {
      promoView: {
        promotions: gtmOptions,
      },
    },
  };
  sendGtmEvent("promotionImpression", options);
};

export const createGtmClickProps = (gtmOptions) => {
  const options = {
    ecommerce: {
      promoClick: {
        promotions: gtmOptions,
      },
    },
  };
  sendGtmEvent("promotionClick", options);
};

export const modifyImage = (src = "") => {
  const splittedImage = src.split("/");
  return splittedImage[splittedImage.length - 1].split(".")[0];
};
